export const API_URL = "https://aria-payment-prd.appspot.com/api";
export const COMPANY_ID = 33;
export const COD_FEE = 330;
// export const ADD_DUE_DATE = 5;
export default API_URL;
